const PREFIX = '';

export const HOME = '/home';
export const PRA = PREFIX + '/paperwork-reduction-act';
export const PAS = PREFIX + '/privacy-act-statement';
export const REGISTER = PREFIX + '/candidate-registration';
export const RESET_PASSWORD = PREFIX + '/user/user/reset/';
export const LOGIN_CHANGE_EMAIL = PREFIX + '/login/change-email';

export function formRedirect(path, params, method) {
    method = method || "post";

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params)
        if(params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
        }

    document.body.appendChild(form);
    form.submit();
}
